import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import MyPageLayout from '../../components/Layouts/MyPage/MyPageLayout.index';
import FW from '../../config/word.json';
import {
  GET_VISITOR_SIMPLE_AUTH_INITIAL,
  GET_VISITOR_SIMPLE_AUTH_REQUEST,
  RESERVE_HISTORY_DETAIL_STATE,
} from '../../store/actions';
import { RootState } from '../../store/reducers';

const SimpleAuth: FC = () => {
  const [birthday, setBirthday] = useState('');
  const [telephone, setTelephone] = useState('');
  const [isNextButtonEnable, setIsNextButtonEnable] = useState(false);
  const { getSimpleAuthResult } = useSelector((state: RootState) => state.simpleAuth);

  const dispatch = useDispatch();
  const history = useHistory();

  const [message, setMessage] = useState('');
  const [birthdayMessage, setBirthdayMessage] = useState('');
  const [telephoneMessage, setTelephoneMessage] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
    setMessage('');
    dispatch({
      type: GET_VISITOR_SIMPLE_AUTH_INITIAL,
    });
    return () => {
      dispatch({
        type: GET_VISITOR_SIMPLE_AUTH_INITIAL,
      });
    };
  }, []);

  useEffect(() => {
    setIsNextButtonEnable(birthday !== '' && telephone !== '');
  }, [birthday, telephone]);

  const handleBirthdayChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setBirthdayMessage('');
    const birthdayValue = e.target.value;
    const formattedValue = birthdayValue.replace(/[^0-9]/g, '');
    setBirthday(formattedValue);
  };

  const handleTelephoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTelephoneMessage('');
    const numericValue = e.target.value.replace(/[^0-9]/g, '');
    if (numericValue.length > 11) {
      return;
    }
    setTelephone(e.target.value);
  };

  const getLastDayFromMonth = (index: number) => {
    const days = [0, 31, Number(birthday.substring(0, 4)) % 4 === 0 ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    return days[index];
  };

  const checkBornDate = (bday: string) => {
    let isValid = true;
    const month = Number(bday.substring(4, 6));
    const date = Number(bday.substring(6));
    if (date > getLastDayFromMonth(month)) {
      isValid = false;
    }
    return isValid;
  };

  const checkBirthday = (bday: string) => {
    if (bday !== '' && bday !== null && bday?.length === 8) {
      const bdayStyled = `${bday.substring(0, 4)}/${bday.substring(4, 6)}/${bday.substring(6)}`;
      const checkRegex = /^(19|20)\d{2}\/(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])$/;
      if (checkRegex.test(bdayStyled)) {
        if (checkBornDate(bday)) {
          return true;
        }
      }
    }
    return false;
  };

  const isPhoneCheck = (mobile: string): boolean => {
    if (
      mobile !== '' &&
      mobile !== null &&
      (mobile.length === 10 || mobile.length === 11) &&
      mobile.match(/^[0-9]+$/) != null
    ) {
      return true;
    }
    return false;
  };

  const handleAuthSubmit = () => {
    setMessage('');
    let err = false;
    if (!checkBirthday(birthday)) {
      err = true;
      setBirthdayMessage('生年月日が不正です。');
    }
    if (!isPhoneCheck(telephone)) {
      err = true;
      setTelephoneMessage('電話番号が不正です。');
    }
    if (err) {
      return;
    }
    dispatch({
      type: GET_VISITOR_SIMPLE_AUTH_REQUEST,
      birthday,
      telephone,
    });
  };

  const handleGoMainPage = () => {
    history.push('/');
  };

  useEffect(() => {
    if (getSimpleAuthResult.isLoaded) {
      if (getSimpleAuthResult.result !== 0) {
        // setIsModalOpen(true);
        setMessage(getSimpleAuthResult.message || '');
      } else {
        // setIsModalOpen(false);
        setMessage('');
        sessionStorage.setItem('simpleAuthResult_visitorId', getSimpleAuthResult.visitorId || '');
        sessionStorage.setItem('simpleAuthResult_birthday', birthday || '');
        sessionStorage.setItem('simpleAuthResult_telephone', telephone || '');
        if (
          getSimpleAuthResult.visitorId !== null &&
          getSimpleAuthResult.visitorId !== '' &&
          getSimpleAuthResult.historyId !== null &&
          getSimpleAuthResult.historyId !== 0
        ) {
          history.push('/history');
        }
        if (
          getSimpleAuthResult.historyId === 0 &&
          getSimpleAuthResult.visitorId !== null &&
          getSimpleAuthResult.visitorId !== ''
        ) {
          dispatch({
            type: RESERVE_HISTORY_DETAIL_STATE,
            transitionTarget: true,
            historyId: '0',
          });
          history.push('/history/detail');
        } else if (getSimpleAuthResult.historyId !== 0 && getSimpleAuthResult.reservationCount === 1) {
          dispatch({
            type: RESERVE_HISTORY_DETAIL_STATE,
            transitionTarget: true,
            historyId: getSimpleAuthResult.historyId.toString(),
          });
          history.push('/history/detail');
        } else {
          history.push('/history');
        }
      }
    }
  }, [getSimpleAuthResult]);

  return (
    <>
      <MyPageLayout>
        <main className="main-layout l-main">
          <section className="p-title-area">
            <p className="c-title">予約確認</p>
          </section>
          <section className="p-content-area u-gap50">
            <div className="p-content-area__column u-gap50 u-sp-gap30">
              <p className="c-read">予約確認のため、予約時にご登録された下記情報を入力してください。</p>
              <div className="p-content-area__column p-content-area__column--width600 u-gap20 u-sp-gap40">
                {/* ラジオボタン */}
                {/* <div className="p-form-item p-form-item--row">
                  <div className="p-form-item__label">
                    性別<span className="p-form-item__required">必須</span>
                  </div>
                  <div className="p-form-item__input-container u-gap20">
                    <div className="p-form-item__input-group">
                      <div className="c-radio-button">
                        <input
                          id="gender-male"
                          className="c-radio-button__input"
                          type="radio"
                          name="gender"
                          value="1"
                          checked={sex === '1'}
                          onChange={(e) => setSex(e.target.value)}
                        />
                        男性
                      </div>
                    </div>
                    <div className="p-form-item__input-group">
                      <div className="c-radio-button">
                        <input
                          id="gender-female"
                          className="c-radio-button__input"
                          type="radio"
                          name="gender"
                          value="2"
                          checked={sex === '2'}
                          onChange={(e) => setSex(e.target.value)}
                        />
                        女性
                      </div>
                    </div>
                  </div>
                </div> */}
                {/* インプット */}
                <div className="p-form-item p-form-item--row">
                  <div className="p-form-item__label">
                    生年月日<span className="p-form-item__required">必須</span>
                  </div>
                  <div className="c-input c-input--width146">
                    <input
                      id="birthday"
                      className="c-input__window"
                      type="text"
                      placeholder="00000000"
                      value={birthday}
                      onChange={handleBirthdayChange}
                      maxLength={8}
                    />
                  </div>
                  <div
                    style={{
                      color: '#d60035',
                      textAlign: 'start',
                      width: '100%',
                      whiteSpace: 'break-spaces',
                      wordBreak: 'break-all',
                      gridColumnStart: '2',
                    }}
                  >
                    {birthdayMessage}
                  </div>
                  <p className="p-form-item__note">※記入例：1991年5月18日→19910518</p>
                </div>
                {/* / インプット */}
                {/* インプット */}
                <div className="p-form-item p-form-item--row">
                  <div className="p-form-item__label">
                    連絡先電話番号<span className="p-form-item__required">必須</span>
                  </div>
                  <div className="c-input c-input--width255">
                    <input
                      id="phone-number"
                      className="c-input__window"
                      type="text"
                      placeholder="00000000000"
                      value={telephone}
                      onChange={handleTelephoneChange}
                    />
                  </div>
                  <div
                    style={{
                      color: '#d60035',
                      textAlign: 'start',
                      width: '100%',
                      whiteSpace: 'break-spaces',
                      wordBreak: 'break-all',
                      gridColumnStart: '2',
                    }}
                  >
                    {telephoneMessage}
                  </div>
                  <p className="p-form-item__note">※記入例：08012345678</p>
                </div>
                {/* / インプット */}
              </div>
            </div>
          </section>
          <section
            className="p-button-area"
            style={{ display: 'flex', flexDirection: 'column', gap: '0px', padding: '0' }}
          >
            <div
              style={{
                color: '#d60035',
                textAlign: 'start',
                whiteSpace: 'break-spaces',
                wordBreak: 'break-all',
                gridColumnStart: '2',
                marginBottom: '20px',
              }}
            >
              {message}
            </div>
            {/* ボタン */}
            <button
              type="button"
              className="c-button c-button--primary c-button--large"
              onClick={handleAuthSubmit}
              disabled={!isNextButtonEnable}
              style={{ marginBottom: '40px' }}
            >
              {getSimpleAuthResult.isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                  {FW.F_W_LOADING}
                </>
              ) : (
                <>予約を確認する</>
              )}
            </button>
            {/* ボタン */}
            <button type="button" className="c-button c-button--secondary c-button--small" onClick={handleGoMainPage}>
              トップに戻る
            </button>
          </section>
        </main>
      </MyPageLayout>
    </>
  );
};

export default SimpleAuth;
